<template>
  <div class="patentList fatherHeight contBox">
    <div class="bar-title">查询条件</div>
    <div>
      <div class="search-top">
        <el-form
          :inline="true"
          :model="searchData"
          ref="searchForm"
          class="demo-form-inline"
          :label-width="120"
          label-suffix=":"
        >
          <el-form-item label="结算日期">
            <el-date-picker
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              v-model="searchData.day_time"
              type="date"
              placeholder="请选择"
            ></el-date-picker>
          </el-form-item>
          <!-- <el-form-item label="收款员">
            <el-select v-model="searchData.doctor_id" placeholder="请选择" clearable>
              <el-option v-for="item in dictList.duty_doctor" :key="item.id" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item> -->
          <div></div>
          <div class="searchBut">
            <el-button class="color-main" @click="resetForm" type="primary">
              <i class="fa fa-refresh"></i>重置
            </el-button>
            <el-button @click="handleSearch" class="color-main" type="primary">
              <i class="fa fa-search"></i>查询
            </el-button>
          </div>
        </el-form>
      </div>
    </div>
    <el-divider></el-divider>
    <div class="patientList" ref="tableBoxRef">
      <div class="table" id="printArea" ref="printView">
        <div class="patentList fatherHeight contBox">
          <div class="box-info">
            <el-table
              v-loading="dataListLoading"
              :data="tableData"
              border
              v-if="istable"
              :max-height="tableHei"
              style="width: 100%"
            >
              <el-table-column
                prop="psn_name"
                label="结算发票号"
                fixed
                width="150"
              />
              <el-table-column
                prop="patient_id"
                label="发票张数"
                fixed
                width="100"
              />
              <el-table-column
                prop="bed_reg_id"
                label="病历号"
                fixed
                width="150"
              />
              <el-table-column prop="insutype" label="姓名" fixed width="100" />
              <el-table-column prop="setl_time" label="总额" width="150" />
              <el-table-column prop="medfee_sumamt" label="自费" width="150" />
              <el-table-column prop="psn_cash_pay" label="报销" width="150" />
              <el-table-column prop="fund_pay_sumamt" label="状态" width="80" />
              <el-table-column
                prop="fund_pay_sumamt"
                label="结算类别"
                width="100"
              />
              <el-table-column
                prop="fund_pay_sumamt"
                label="支付方式"
                width="100"
              />
              <el-table-column
                prop="fund_pay_sumamt"
                label="医疗证号"
                width="150"
              />
              <el-table-column
                prop="fund_pay_sumamt"
                label="身份证号"
                width="150"
              />
              <el-table-column
                prop="fund_pay_sumamt"
                label="诊断信息"
                width="150"
                show-overflow-tooltip
              />
              <el-table-column
                prop="fund_pay_sumamt"
                label="联系电话"
                width="150"
              />
              <el-table-column
                prop="fund_pay_sumamt"
                label="收费员"
                width="100"
              />
              <el-table-column
                prop="fund_pay_sumamt"
                label="收费时间"
                width="150"
              />
              <el-table-column
                prop="fund_pay_sumamt"
                label="日结时间"
                width="150"
              />
              <el-table-column
                prop="fund_pay_sumamt"
                label="收费方式"
                width="150"
              />
              <el-table-column
                prop="fund_pay_sumamt"
                label="金额"
                width="150"
              />
              <el-table-column
                prop="fund_pay_sumamt"
                label="备注"
                width="150"
                show-overflow-tooltip
              />
            </el-table>
          </div>
          <div class="pagination-box">
            <el-pagination
              :currentPage="pageData.currentPage"
              :page-size="pageData.pageSize"
              :page-sizes="[10, 20, 50, 100]"
              :background="true"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageData.totalSum"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  reactive,
  toRefs,
  ref,
  nextTick,
  onMounted,
  onBeforeUnmount,
  getCurrentInstance,
} from 'vue'
import service from '@/utils/request'
import {
  gitDictList,
  gitDictVal,
  TimestampToTime,
  downLoadXlsx,
} from '@/utils/tool'
import { ElMessageBox, ElMessage, ElNotification } from 'element-plus'
import viewDialog from '../../registerList/viewDialog.vue'
export default {
  name: 'patentList',
  components: {
    viewDialog,
  },
  setup() {
    const { proxy } = getCurrentInstance()
    const state = reactive({
      searchData: {
        day_time: '',
      },
      print: {
        id: 'printArea',
        popTitle: '月结明细',
      },
      pageData: {
        currentPage: 1,
        pageSize: 10,
        totalSum: 0,
      },
      dataListLoading: false,
      tableData: [],
      tableHei: 0,
      istable: false,
      tableBoxRef: null,
      info: '',
    })
    onMounted(() => {
      state.searchData.day_time = TimestampToTime()
      state.istable = false
      state.tableHei = state.tableBoxRef.clientHeight - 10
      console.log(state.tableHei)
      nextTick(() => {
        state.istable = true
      })
      getDataList()
    })
    const handleSizeChange = (val) => {
      state.pageData.pageSize = val
      getDataList()
    }

    const handleCurrentChange = (val) => {
      state.pageData.currentPage = val
      getDataList()
    }

    const resetForm = () => {
      state.searchData.day_time = TimestampToTime()
      handleSearch()
    }
    const handleSearch = () => {
      state.pageData.currentPage = 1
      getDataList()
    }

    const getDataList = async () => {
      state.dataListLoading = true
      let res = await service.post('/api/settle/getDaySettle', state.searchData)
      state.dataListLoading = false
      if (res.code === 0) {
        state.info = res.data
        state.tableData = res.data.settle_list
      }
    }

    const exportTable = (row) => {
      let data = {}
      if (state.searchData.day_time) {
        data = {
          start_day_time: state.searchData.day_time[0],
          end_day_time: state.searchData.day_time[1],
          dict_department: state.searchData.dict_department,
          cert_no: state.searchData.cert_no,
          name: state.searchData.name,
          doctor_id: state.searchData.doctor_id,
          dict_status: state.searchData.dict_status,
        }
      } else {
        data = {
          dict_department: state.searchData.dict_department,
          cert_no: state.searchData.cert_no,
          name: state.searchData.name,
          doctor_id: state.searchData.doctor_id,
          dict_status: state.searchData.dict_status,
        }
      }
      let day_time = TimestampToTime()
      let title = `月结明细${day_time}.xlsx`
      downLoadXlsx('/api/store_out_record/export_out_list', data, title)
    }
    const printFile = () => {
      proxy.$print(proxy.$refs.printView)
    }
    return {
      ...toRefs(state),
      handleSizeChange,
      handleCurrentChange,
      handleSearch,
      getDataList,
      resetForm,
      exportTable,
      printFile,
    }
  },
}
</script>
<style lang="scss">
.el-notification__group {
  flex: 1;
}

.notice_but {
  text-align: right;
  color: #3167a8;
  cursor: pointer;
}
</style>
<style scoped lang="scss">
.demo-form-inline {
  margin-top: 0;
  //flex: 1;
  display: grid;
  grid-template-columns: 33% 33% 33%;
  grid-template-rows: repeat(1, 40px);
  align-items: center;

  .el-form-item {
    margin-bottom: 0;
  }
}

.search-top .w-208 {
  width: 208px;
}

.table-tag {
  margin-right: 8px;
}

.fa-stack {
  width: 24px;
  height: 24px;
  cursor: pointer;
  float: right;

  .fa-stack-2x {
    font-size: 24px;
    color: rgba(49, 102, 174, 0.1);
  }

  .fa-stack-1x {
    font-size: 12px;
    color: #3166ae;
    line-height: 24px;
  }
}

.tagBox {
  display: flex;
  justify-content: flex-start;

  // margin-bottom: 10px;
  .tit {
    width: 83px;
    font-size: 14px;
    font-family: 'Source Han Sans CN-Bold';
    font-weight: bold;
    color: #666666;
  }

  .cont {
    width: calc(100% - 83px);
  }
}

.patientList {
  margin-top: 4px;
  height: calc(100% - 220px);
}

.list-top {
  .name {
    font-size: 18px;
    font-family: ' Source Han Sans CN-Medium';
    font-weight: 500;
    color: #000000;
    line-height: 32px;
  }
}

.patient-alert {
  background: rgba(49, 102, 174, 0.1);
  border-radius: 4px 4px 4px 4px;
  font-size: 18px;
  color: #3166ae;
  margin-top: 8px;
  padding: 4px 16px;

  .el-alert__icon {
    color: #3166ae;
  }

  &:deep(.el-alert__content) {
    position: relative;
    top: 3px;
  }
}

.table {
  margin-top: 10px;
  height: calc(100% - 10px);

  .img {
    width: 25px;
    height: 24px;
    margin-right: 14px;
  }
}

.searchBut {
  width: 100%;
  display: flex;
  justify-content: end;
  margin-right: 28px;
}

.del {
  background-color: #ffecec;
  color: #ff6b6b;
  font-weight: 700;
}

.modify {
  background-color: #3166ae;
}

.bar-title {
  font-size: 18px;
  line-height: 18px;
  color: #000000;
  border-left: 6px solid #3166ae;
  padding: 0 18px;
  margin-bottom: 16px;
  font-weight: bold;
}

.labelSet1 {
  width: 60px;
  height: 30px;
  line-height: 30px;
  display: block;
  text-align: center;
  color: #fff;
  border-radius: 5px;
}

.psckset {
  background-color: #409eff;
}

.psckset1 {
  background-color: #a4cef8;
  color: #1581fc;
  border: 1px solid #1581fc;
}

.lcsyset {
  background-color: #c6f1b1;
  color: #3bb207;
  border: 1px solid #5bd324;
}

.lcsyset1 {
  background-color: #f1beb1;
  color: #f35c0c;
  border: 1px solid #f35c0c;
}

.info-table {
  width: 100%;
  margin: 10px 0;

  tr {
    height: 40px;
  }

  td {
    padding-left: 20px;
  }

  .color-blue {
    color: #3166ae;
    font-size: 14px;
    width: 230px;
  }

  .border-right {
    /* border-right: 1px solid gray; */
  }
}

.info-table tr:nth-child(2n + 1) {
  background-color: rgba(49, 102, 174, 0.1);
}

.momey-total {
  display: flex;
  margin: 10px;
  line-height: 30px;
  font-size: 14px;

  .item {
    margin-right: 20px;
    width: 150px;
    color: #444;
  }
}

.momey-total1 {
  display: flex;
  margin: 10px;
  line-height: 30px;
  font-size: 14px;

  .item1 {
    margin-right: 20px;
    width: 350px;
    color: #444;
  }

  .item {
    margin-right: 20px;
    width: 250px;
    color: #444;
  }
}
</style>
